import { Divider } from 'antd';

const HVDivider = props => {
    return <Divider {...props} />;
};

export default HVDivider;
